export default "__VITE_ASSET__CfrkEBbO__"